import styled from "styled-components"

import { minWidth } from "utils"

export const Container = styled.div`
  padding: 0 1.2rem 4rem;
  background-color: #fff;

  ${minWidth.desktop`
    padding: 6rem 12rem;
  `}
`

export const Title = styled.div`
  margin-bottom: 6rem;
  display: none;
  font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 3.6rem;
  text-align: center;
  color: #222;

  ${minWidth.desktop`
    display: block;
  `}
`
